import { history, Login, Input, Button, Form, FormItem, GetValidateFields } from 'asumsi-components';
import React, { Fragment, useState } from 'react';
import DocumentTitle from 'react-document-title';
import useAction from './hooks/useAction';
import changePasswordAction from "@pages/change-password/hooks/useAction";
import { IParamLogin } from '@interfaces/iparam-login';
import { setSessionLogin } from '@helpers/cookies';
import { IChangePassword } from '@interfaces/iparam-change-password';

interface IProps {
  form: any;
}

export const PageLoginComponent = (props: IProps) => {
  const { postData, isLoader } = useAction();
  const { postData: changePass, isLoader: isLoaderChange } = changePasswordAction();
  const [firstLogin, setFirstLogin] = useState(false);
  const [token, setToken] = useState("");
  const [oldPwd, setOldPwd] = useState(process.env.REACT_APP_DEFAULT_PASSWORD ?? 'Asumsi123igfy')

  // initiate form data
  const initialFieldsValues: IParamLogin = {
    email: "",
    password: "",
  };

  const initialFieldsFirsLoginValues: IChangePassword = {
    oldPassword: "",
    newPassword: "",
    newPasswordConfirm: "",
  };

  const [fieldsValues, setFieldsValues]: any = useState(initialFieldsValues);
  const [fieldsPwdValues, setFieldsPwdValues]: any = useState(initialFieldsFirsLoginValues);

  const handleSubmit = async (e: any) => {
    const validateFields: any = GetValidateFields(fieldsValues);
    const { err, values } = validateFields;
    e.preventDefault();
    if (!err) {
      let val: any = values;
      val = { ...val, appCode: "CMS" }
      const response = await postData(val);
      if (response && response.accessToken) {
        setToken(response.accessToken)
        setOldPwd(val.password);
        if (val.password == (process.env.REACT_APP_DEFAULT_PASSWORD ?? 'Asumsi123igfy')) {
          setFirstLogin(true);
        } else {
          setSessionLogin(response);
          history.push({
            pathname: '/dashboard',
          });
        }
      }
    }
  };

  const changePasswordSumbit = async (e: any) => {
    const validateFields: any = GetValidateFields(fieldsPwdValues);
    const { err, values } = validateFields;
    e.preventDefault();
    if (!err) {
      let val: any = values;
      val = { ...val, oldPassword: oldPwd }
      const response = await changePass(val, token);
      if (response) {
        history.push({
          pathname: '/dashboard',
        });
      }
    }
  };

  const onKeyUpPassword = (e: any) => {
    if (e.key == "Enter") handleSubmit(e);
  }

  const onKeyUpPasswordConfirm = (e: any) => {
    if (e.key == "Enter") changePasswordSumbit(e);
  }

  return (
    <Fragment>
      <DocumentTitle title="Login" />
      <Login>
        {firstLogin ? <div>
          <div className="content-url">Please change your password first !</div>
          <Form loading={true}>
            <FormItem label="" hideRequiredMark={true} fieldsValues={fieldsPwdValues} setFieldsValues={setFieldsPwdValues} fieldDecorator={{
              label: "newPassword",
              rules: [
                {
                  required: true,
                  hideErrorMessage: true
                },
                {
                  message: 'The password minimum is 8 character',
                  min: 8
                },
              ]
            }}>
              <Input autoComplete="off" type="password" id="newPassword" icon="lock" placeHolder="newPassword" />
            </FormItem>
            <FormItem label="" hideRequiredMark={true} fieldsValues={fieldsPwdValues} setFieldsValues={setFieldsPwdValues} fieldDecorator={{
              label: "newPasswordConfirm",
              rules: [
                {
                  required: true,
                  hideErrorMessage: true
                },
                {
                  message: 'The password confirm minimum is 8 character',
                  min: 8
                },
              ]
            }}>
              <Input autoComplete="off" type="password" id="newPasswordConfirm" icon="lock" placeHolder="newPasswordConfirm" onKeyUp={onKeyUpPasswordConfirm} />
            </FormItem>
            <Button
              type="primary"
              text="Save"
              loadingText="Processing"
              loading={isLoaderChange}
              disabled={fieldsPwdValues.errors && fieldsPwdValues.errors.length > 0}
              onClick={changePasswordSumbit} />
          </Form>
        </div>
          : <Form loading={true}>
            <FormItem hideRequiredMark={true} fieldsValues={fieldsValues} setFieldsValues={setFieldsValues} fieldDecorator={{
              label: "email",
              rules: [
                {
                  required: true,
                  hideErrorMessage: true
                },
                {
                  type: 'email',
                  message: "That doesn't look like an email address",
                }
              ]
            }}>
              <Input autoComplete="off" id="email" icon="envelope" placeHolder="Email Address" />
            </FormItem>
            <FormItem label="" hideRequiredMark={true} fieldsValues={fieldsValues} setFieldsValues={setFieldsValues} fieldDecorator={{
              label: "password",
              rules: [
                {
                  required: true,
                  hideErrorMessage: true
                },
                {
                  message: 'The password minimum is 8 character',
                  min: 3
                },
              ]
            }}>
              <Input autoComplete="off" type="password" id="password" icon="lock" placeHolder="Password" onKeyUp={onKeyUpPassword} />
            </FormItem>
            <Button
              type="primary"
              text="Login"
              loadingText="Processing"
              loading={isLoader}
              disabled={fieldsValues.errors && fieldsValues.errors.length > 0}
              onClick={handleSubmit} />
          </Form>}

      </Login>
    </Fragment >
  );
};

export default PageLoginComponent;



// WEBPACK FOOTER //
// ./src/pages/login/component.tsx